// Simple scroll utility - doesn't interfere with native momentum scrolling
export const smoothScrollTo = (targetId) => {
  const target = document.querySelector(targetId);
  if (!target) return;

  const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
  const padding = 20;

  window.scrollTo({
    top: Math.max(0, targetTop - padding),
    behavior: "auto"
  });
};
